<script>
    import { createEventDispatcher } from "svelte";
    
    export let biggerIcon = null;
    export let text = "↑ Load latest";
        
    const dispatch = createEventDispatcher();
    
</script>

<button on:click={() => dispatch('loadLatest')}>
    {#if biggerIcon}
        <span>{biggerIcon}</span>
    {/if}
    {text}
</button>

<style>
    button {
		position: absolute;
		left: 50%;
        top: -1rem;
		transform: translateX(-50%);
		background: #EDF22C;
		z-index: 9;
		border-radius: 10rem;
		padding: 1rem 2rem;
		color: #341153;
		line-height: 1;
		white-space: nowrap;
	}
    span {
        font-size: 1em;
        line-height: 1;
    }
</style>